import gql from 'graphql-tag';

const getTeamContracts = gql`
  query getTeamContracts($organisationId: String!, $teamId: String!, $status: String) {
    getTeamContracts(
      organisationId: $organisationId,
      teamId: $teamId,
      status: $status
    ) {
      Payload
    }
  }
`;

export default (() => ({
  query: getTeamContracts,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: (data) => {
    const {
      organisationId,
      teamId,
      status
    } = data;
    return {
      organisationId,
      teamId,
      status
    };
  }
}));